/**
 * Anubis Wishlist — localStorage-based favorites.
 * Works with wishlist-button.liquid snippet on product cards and PDP.
 */

(function () {
  const STORAGE_KEY = 'anubis-wishlist';

  // Formato actual: [{id, handle}]. Se aceptan listas antiguas de solo ids.
  function getEntries() {
    let raw;
    try { raw = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
    if (!Array.isArray(raw)) return [];
    return raw
      .map((item) =>
        typeof item === 'string'
          ? { id: item, handle: null }
          : item && item.id
            ? { id: String(item.id), handle: item.handle || null }
            : null
      )
      .filter(Boolean);
  }

  function saveEntries(entries) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(entries)); } catch {}
  }

  function getWishlist() {
    return getEntries().map((e) => e.id);
  }

  function isInWishlist(id) {
    return getWishlist().includes(String(id));
  }

  function toggleWishlist(id, handle) {
    const entries = getEntries();
    const sid = String(id);
    const idx = entries.findIndex((e) => e.id === sid);
    if (idx === -1) {
      entries.push({ id: sid, handle: handle || null });
    } else {
      entries.splice(idx, 1);
    }
    saveEntries(entries);
    return idx === -1; // true = agregado
  }

  function updateButtons(productId, active) {
    document.querySelectorAll(`[data-wishlist-toggle][data-product-id="${productId}"]`).forEach(btn => {
      btn.classList.toggle('anubis-wishlist-btn--active', active);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Agregar a favoritos');
    });
  }

  function updateBadge() {
    const count = getWishlist().length;
    document.querySelectorAll('.anubis-wishlist-badge').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function initButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const id = btn.dataset.productId;
      if (!id) return;
      const active = isInWishlist(id);
      btn.classList.toggle('anubis-wishlist-btn--active', active);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Agregar a favoritos');
    });
  }

  // Handle clicks via delegation
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.dataset.productId;
    if (!id) return;
    const added = toggleWishlist(id, btn.dataset.productHandle);
    updateButtons(id, added);
    updateBadge();

    // Small pulse feedback
    btn.classList.add('anubis-wishlist-btn--pulse');
    setTimeout(() => btn.classList.remove('anubis-wishlist-btn--pulse'), 400);
  });

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initButtons(); updateBadge(); });
  } else {
    initButtons();
    updateBadge();
  }

  // Re-init when Shopify section renders (theme editor / dynamic sections)
  document.addEventListener('shopify:section:load', () => { initButtons(); updateBadge(); });

  // Expose API
  window.AnubisWishlist = { getWishlist, getEntries, isInWishlist, toggleWishlist, updateBadge };
})();
